/* src/app/mass-section/mass-section.component.scss */
:host {
  display: block;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  background: #fff;
  --accent: #0c447c;
  --accent-light: #e6f1fb;
  --bg-secondary: #f7f7f5;
  --bg-page: #fff;
  --text-primary: #1a1a1a;
  --text-secondary: #6b6b6b;
  --text-tertiary: #999;
  --border: rgba(0, 0, 0, 0.1);
  --border-hover: rgba(0, 0, 0, 0.2);
  --purple-bg: #eeedfe;
  --purple-text: #3c3489;
}
.ms-shell {
  display: flex;
  height: 100%;
}
.ms-shell.ms-resizing {
  cursor: col-resize;
  -webkit-user-select: none;
  user-select: none;
}
.ms-handle {
  width: 5px;
  flex-shrink: 0;
  background: var(--border);
  cursor: col-resize;
  transition: background 0.15s;
}
.ms-handle:hover {
  background: var(--accent);
}
.ms-source {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  background: #fff;
  min-height: 0;
  overflow: hidden;
  padding: 16px 0;
}
.ms-source-head,
.ms-preview-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px 12px;
}
.ms-source-head span,
.ms-preview-head span {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.03em;
  color: var(--text-secondary);
}
.ms-search {
  position: relative;
  padding: 0 12px 12px;
}
.ms-search input {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 10px;
  border: 0.5px solid var(--border);
  border-radius: 8px;
  background: var(--bg-secondary);
  font-size: 12px;
  color: var(--text-primary);
  outline: none;
}
.ms-search input:focus {
  border-color: var(--accent);
  background: #fff;
}
.ms-dropdown {
  position: absolute;
  top: 33px;
  left: 12px;
  right: 12px;
  border: 1px solid var(--border);
  border-radius: 0 0 12px 12px;
  border-top: 0;
  background: #fff;
  max-height: 240px;
  overflow: auto;
  z-index: 25;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.18) transparent;
}
.ms-dropdown-item {
  padding: 9px 12px;
  font-size: 13px;
  color: var(--text-secondary);
  cursor: pointer;
  text-align: left;
}
.ms-dropdown-item:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}
.ms-source-meta {
  padding: 6px 16px 10px;
  border-bottom: 0.5px solid var(--border);
  margin-bottom: 4px;
}
.ms-source-name {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ms-source-type {
  font-size: 11px;
  color: var(--text-tertiary);
  text-transform: capitalize;
}
.ms-tree {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding-bottom: 16px;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.18) transparent;
}
.ms-tree::-webkit-scrollbar {
  width: 8px;
}
.ms-tree::-webkit-scrollbar-track {
  background: transparent;
}
.ms-tree::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18);
  border-radius: 999px;
  border: 2px solid #fff;
}
::ng-deep .ms-tree app-tree .tree-item {
  border: 0;
  background: transparent;
  border-radius: 10px;
  padding: 7px 10px;
  color: var(--text-secondary);
  cursor: default;
}
::ng-deep .ms-tree app-tree .tree-item:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}
::ng-deep .ms-tree app-tree .action-icon {
  display: none !important;
}
::ng-deep .ms-tree app-tree .toggle-btn {
  display: none !important;
}
::ng-deep .ms-tree app-tree .select-route-btn {
  margin-right: 6px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  background: #fff;
  color: var(--text-secondary);
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  padding: 2px 6px;
  height: 22px;
  letter-spacing: 0.03em;
  transition:
    background 0.12s,
    border-color 0.12s,
    color 0.12s;
}
::ng-deep .ms-tree app-tree .select-route-btn:hover {
  background: var(--accent-light);
  border-color: var(--accent);
  color: var(--accent);
}
::ng-deep .ms-tree app-tree .select-route-btn.active {
  background: var(--accent-light);
  border-color: var(--accent);
  color: var(--accent);
  box-shadow: inset 0 1px 3px rgba(12, 68, 124, 0.15);
}
::ng-deep .ms-tree app-tree .tree-item.sidebar-selected {
  background: var(--accent-light);
  color: var(--accent);
  border-left: 2px solid var(--accent);
}
::ng-deep .ms-tree app-tree .item-tag {
  min-width: 50px;
  border: 0;
  border-radius: 6px;
  background: var(--purple-bg);
  color: var(--purple-text);
  font-size: 10px;
  font-weight: 700;
  text-transform: lowercase;
  text-align: center;
  padding: 2px 8px;
}
::ng-deep .ms-tree app-tree .item-content {
  margin-left: 8px;
  max-width: none;
  font-size: 13px;
  line-height: 1.45;
}
::ng-deep .ms-tree app-tree .children-container {
  margin-left: 8px;
  padding-left: 16px;
  border-left: 1px dashed rgba(0, 0, 0, 0.08);
}
.ms-preview {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  background: #fff;
  min-height: 0;
  overflow: hidden;
  padding: 16px 0;
}
.ms-auto-select-btn {
  padding: 3px 10px;
  border-radius: 6px;
  border: 0.5px solid var(--border);
  background: #fff;
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
}
.ms-auto-select-btn:hover:not(:disabled) {
  background: var(--bg-secondary);
}
.ms-auto-select-btn:disabled {
  opacity: 0.4;
  cursor: default;
}
.ms-preview-link {
  font-size: 11px;
  color: var(--accent);
  white-space: nowrap;
  cursor: pointer;
}
.ms-preview-link:hover {
  text-decoration: underline;
}
.ms-targets {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  background: var(--bg-secondary, #f8f9fa);
  overflow: hidden;
  padding: 16px;
  gap: 12px;
}
.ms-targets-head {
  padding: 4px 0 2px;
}
.ms-targets-head span {
  font-size: 12px;
  color: var(--text-secondary);
}
.ms-filters {
  display: flex;
  gap: 8px;
  align-items: center;
}
.ms-filters select {
  width: 130px;
  padding: 6px 10px;
  border: 0.5px solid var(--border);
  border-radius: 8px;
  background: #fff;
  font-size: 13px;
  color: var(--text-primary);
  outline: none;
}
.ms-filters input {
  flex: 1;
  padding: 6px 10px;
  border: 0.5px solid var(--border);
  border-radius: 8px;
  background: #fff;
  font-size: 13px;
  color: var(--text-primary);
  outline: none;
}
.ms-filters input:focus {
  border-color: var(--accent);
}
.ms-filters button {
  padding: 6px 14px;
  border-radius: 8px;
  border: 0.5px solid var(--border);
  background: #fff;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
}
.ms-filters button:hover:not(:disabled) {
  background: var(--bg-secondary);
}
.ms-filters button:disabled {
  opacity: 0.5;
  cursor: default;
}
.ms-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 0.5px solid var(--border);
}
.ms-check-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--text-secondary);
  cursor: pointer;
  margin: 0;
}
.ms-check-row input[type=checkbox] {
  cursor: pointer;
}
.ms-list {
  flex: 1;
  overflow: auto;
  background: #fff;
  border: 0.5px solid var(--border);
  border-radius: 8px;
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.18) transparent;
}
.ms-list-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 0.5px solid var(--border);
  font-size: 13px;
  color: var(--text-primary);
}
.ms-list-item:last-child {
  border-bottom: none;
}
.ms-list-item:hover {
  background: var(--bg-secondary);
}
.ms-list-item.active {
  background: var(--accent-light);
  color: var(--accent);
}
.ms-list-item input[type=checkbox] {
  flex-shrink: 0;
  cursor: pointer;
}
.ms-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 8px 0 4px;
  flex-shrink: 0;
}
.ms-pagination span {
  font-size: 12px;
  color: var(--text-secondary);
  min-width: 48px;
  text-align: center;
}
.ms-pagination button {
  padding: 4px 10px;
  border-radius: 6px;
  border: 0.5px solid var(--border);
  background: #fff;
  font-size: 13px;
  cursor: pointer;
  line-height: 1;
}
.ms-pagination button:hover:not(:disabled) {
  background: var(--bg-secondary);
}
.ms-pagination button:disabled {
  opacity: 0.4;
  cursor: default;
}
.ms-update-btn {
  white-space: nowrap;
}
.ms-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
.ms-modal {
  background: #fff;
  border-radius: 12px;
  padding: 28px 32px 24px;
  width: 460px;
  max-width: calc(100vw - 40px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}
.ms-modal-title {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 14px;
}
.ms-modal-body {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.6;
  margin: 0 0 10px;
}
.ms-modal-body strong {
  color: var(--text-primary);
  font-weight: 600;
}
.ms-modal-error {
  font-size: 12px;
  color: #c0392b;
  margin: 6px 0 0;
}
.ms-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;
}
.ms-modal-cancel {
  padding: 7px 16px;
  border-radius: 8px;
  border: 0.5px solid var(--border);
  background: #fff;
  font-size: 13px;
  cursor: pointer;
}
.ms-modal-cancel:hover:not(:disabled) {
  background: var(--bg-secondary);
}
.ms-modal-cancel:disabled {
  opacity: 0.5;
  cursor: default;
}
.ms-modal-confirm {
  padding: 7px 18px;
  border-radius: 8px;
  border: none;
  background: var(--accent);
  color: #fff;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.15s;
}
.ms-modal-confirm:hover:not(:disabled) {
  opacity: 0.85;
}
.ms-modal-confirm:disabled {
  opacity: 0.5;
  cursor: default;
}
.ms-hint {
  padding: 20px;
  text-align: center;
  color: var(--text-secondary);
  font-size: 13px;
  font-style: italic;
}
/*# sourceMappingURL=mass-section.component.css.map */
